import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import ContactListItem from 'components/Contacts/ContactListItem';
import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
import dropdownNavigation from 'components/Dropdown/DropdownNavigation';
import ReactInfinite from 'react-infinite';
import ReactDOM from 'react-dom';
import classes from './AddParticipantSearch.module.scss';

const ELEMENT_HEIGHT = 42;

const messages = defineMessages({
  emptyMessage: { id: 'components.addParticipant.emptyMessage', defaultMessage: 'Choose a contact or room system, or enter a number.' },
  noResults: { id: 'components.globalSearch.emptyMessage', defaultMessage: 'There are no matches for your search.' }
});

class AddParticipantSearchResults extends React.PureComponent {
  UNSAFE_componentWillMount() {
    this.setState({ containerHeight: ELEMENT_HEIGHT });
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (nextProps.selectionIndex > this.props.selectionIndex) {
      this.scrollToNextResult();
    }

    if (nextProps.selectionIndex < this.props.selectionIndex) {
      this.scrollToPreviousResult();
    }
  }

  /* eslint-disable react/no-find-dom-node */
  getScrollTop = () => ReactDOM.findDOMNode(this).scrollTop;

  setScrollTop = (scrollTop) => {
    ReactDOM.findDOMNode(this).scrollTop = scrollTop;
  };
  /* eslint-enable react/no-find-dom-node */

  scrollToNextResult = () => {
    const highlightedIndex = this.props.selectionIndex + 2;
    if ((highlightedIndex) * ELEMENT_HEIGHT >
      (this.state.containerHeight + this.getScrollTop())) {
      this.setScrollTop(((highlightedIndex) * ELEMENT_HEIGHT) - this.state.containerHeight);
    }
  };

  scrollToPreviousResult = () => {
    const highlightedIndex = this.props.selectionIndex - 1;

    if (highlightedIndex * ELEMENT_HEIGHT < this.getScrollTop()) {
      this.setScrollTop(highlightedIndex * ELEMENT_HEIGHT);
    }
  };

  render() {
    const {
      searchContacts,
      handleSelectContact,
      searchString,
      selectionIndex,
      showCustomDial,
      isSearching
    } = this.props;
    let returnArray = [];

    if (searchContacts.length) {
      returnArray = (
        searchContacts.map((result, index) =>
          <ContactListItem
            key={result.contact.id}
            className={classes.listItem}
            contact={result.contact}
            matches={result.matches ? result.matches.name : []}
            handleSelectContact={handleSelectContact}
            isHighlighted={index === selectionIndex}
            fontSize="1.1em"
            noButtons
            greyOutUnCallable
            dataTestTag="addParticipant-search-contact"
          />)
      );
    } else if (showCustomDial) {
      returnArray = (
        <ContactListItem
          key={searchString}
          className={classes.listItem}
          contact={{
            name: searchString,
            id: searchString,
            dialString: searchString,
            isManual: true
          }}
          matches={[]}
          handleSelectContact={handleSelectContact}
          isHighlighted={selectionIndex === 0}
          fontSize="1.1em"
          noButtons
          greyOutUnCallable
          dataTestTag="addParticipant-search-custom"
        />
      );
    } else if (searchString && searchString.length && !isSearching) {
      const customStyle = {
        fontSize: '12px',
        textAlign: 'left',
        minHeight: '30px',
        maxHeight: '50px',
        minWidth: '100%',
        padding: '0 8px 0',
        overflow: 'hidden'
      };

      returnArray = (
        <EmptyMessage
          customMessage={this.props.intl.formatMessage(messages.noResults)}
          customStyle={customStyle}
        />
      );
    } else if (!isSearching) {
      const customStyle = {
        fontSize: '12px',
        textAlign: 'left',
        minHeight: '30px',
        maxHeight: '50px',
        minWidth: '100%',
        padding: '0 8px 0',
        overflow: 'hidden'
      };

      returnArray = (
        <EmptyMessage
          customMessage={this.props.intl.formatMessage(messages.emptyMessage)}
          customStyle={customStyle}
        />
      );
    } else {
      returnArray = (
        <div key="searchSpinner" className={classes.loadingContainer}>
          <div className={classes.loadingSpinner} />
        </div>
      );
    }

    return (
      <ReactInfinite
        ref={() => {
          const container = document.getElementById(this.props.inviteContainerId);
          if (container) {
            this.setState({ containerHeight: container.clientHeight - ELEMENT_HEIGHT });
          }
        }}
        id="participantsScroll"
        className={classes.infiniteScroll}
        containerHeight={searchContacts.length ? this.state.containerHeight : 50}
        elementHeight={ELEMENT_HEIGHT}
        styles={{ scrollableStyle: { overflowY: 'auto' } }}
      >
        {returnArray}
      </ReactInfinite>
    );
  }
}

AddParticipantSearchResults.propTypes = {
  searchContacts: PT.array,
  handleSelectContact: PT.func.isRequired,
  searchString: PT.string,
  intl: PT.object,
  selectionIndex: PT.number,
  inviteContainerId: PT.string,
  showCustomDial: PT.bool,
  isSearching: PT.bool
};

export default injectIntl(dropdownNavigation(AddParticipantSearchResults));
